import React from "react";
import { BaseComponent } from "../../utils/BaseComponent";
import { FormValidationError, FormValidationFunction, ValidateEmail, Form, FormTextField } from "@schneiderpp/utils-forms";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ROUTER_AUTH } from "./Router";
interface ResetPasswordSetNewFormFields {
    email: string;
    authenticationCode: string;
    newpassword: string;
}

interface ResetPasswordSetNewState {
    fields: ResetPasswordSetNewFormFields;
    fieldErrors: FormValidationError<ResetPasswordSetNewFormFields>[];
    urlProvided: {
        email: boolean;
        authenticationCode: boolean;
    };
}

const resetPasswordSetNewFormValidate: FormValidationFunction<ResetPasswordSetNewFormFields> = async (fields) => {
    const errors: Array<FormValidationError<ResetPasswordSetNewFormFields>> = [];
    if (!ValidateEmail(fields.email)) {
        errors.push({ fieldName: "email", code: "Invalid Email" });
    }
    if (fields.authenticationCode.length < 3) {
        errors.push({
            fieldName: "authenticationCode",
            code: "Kod autoryzacyjny jest zbyt krótki"
        });
    }
    if (fields.newpassword.length < 6) {
        errors.push({
            fieldName: "newpassword",
            code: "Nowe hasło jest za krótkie (min. 6 znaków)"
        });
    }
    return errors;
};

class ResetPasswordSetNew extends BaseComponent<RouteComponentProps, ResetPasswordSetNewState> {
    state: ResetPasswordSetNewState = {
        fields: {
            email: "",
            authenticationCode: "",
            newpassword: ""
        },
        fieldErrors: [],
        urlProvided: {
            email: false,
            authenticationCode: false
        }
    };

    private form = new Form<ResetPasswordSetNewFormFields>(this, resetPasswordSetNewFormValidate);

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams.get("email"));

        const email = urlParams.get("email");
        const authenticationCode = urlParams.get("code");

        if (!!email && ValidateEmail(email)) {
            this.setState((p) => ({
                fields: { ...p.fields, email: email },
                urlProvided: { ...p.urlProvided, email: true }
            }));
        }

        if (!!authenticationCode && authenticationCode.length >= 6) {
            this.setState((p) => ({
                fields: { ...p.fields, authenticationCode: authenticationCode },
                urlProvided: { ...p.urlProvided, authenticationCode: true }
            }));
        }
    }
    render() {
        return (
            <div className="auth__center">
                <div className="auth__container">
                    <div className="auth__title">Resetuj Hasło</div>
                    {!this.state.urlProvided.email ? (
                        <FormTextField config={this.form.getFieldConfig("email")} label="email" />
                    ) : (
                        <div className="form__label">
                            {this.state.fields.email}
                            <br />
                            <br />
                        </div>
                    )}
                    {!this.state.urlProvided.authenticationCode ? (
                        <FormTextField config={this.form.getFieldConfig("authenticationCode")} label="Kod otrzymany w mailu" />
                    ) : (
                        <div className="form__label">{this.state.fields.authenticationCode}</div>
                    )}
                    <FormTextField config={this.form.getFieldConfig("newpassword")} label="Nowe hasło" type="password" />
                    <button className="button" onClick={() => this.resetPasswordSetNew()}>
                        Zatwierdź
                    </button>
                </div>
            </div>
        );
    }

    private async resetPasswordSetNew() {
        try {
            const isValid = await this.form.validate();
            if (isValid) {
                await this.context.Authorization.resetPasswordSetNewPassword(
                    this.form.fields.email,
                    this.form.fields.authenticationCode,
                    this.form.fields.newpassword
                );

                this.props.history.push({ pathname: ROUTER_AUTH.Login });
            }
        } catch (e) {
            this.setState((p) => ({
                ...p,
                fieldErrors: [
                    {
                        fieldName: "authenticationCode",
                        code: `Wystąpił błąd podczas zmiany hasła (${(e as any)?.message ?? "nieznany błąd"})`
                    }
                ]
            }));
            console.log(e);
        }
    }
}

export default withRouter(ResetPasswordSetNew);
